import SimpleCard from 'components/global/SimpleCard';
import moment from 'moment';
import { Button } from 'react-bootstrap';

const Notification = ({ onDismiss, notification: {
  title,
  type,
  description,
  // Todo: DLS-1305 - Add linkText and linkPath
  // linkText,
  // linkPath,
  createdAt,
  id,
} }) => (
  <SimpleCard className="bg-secondary">
    <div className="d-flex justify-content-between align-items-start">
      <div>
        <p className="text-gradient-warning-primary mb-16">New {type}</p>
        <h5 className="fw-600">{title}</h5>
      </div>
      <Button
        className="bg-transparent text-primary border-0 p-0"
        onClick={() => onDismiss(id)}
      >
        <span className="visually-hidden-focusable">Close</span>
        <span className="icon-close d-block" />
      </Button>
    </div>
    <p>{description?.replace(/@\[([^[\]]+)\]\(\d+\)/g, '$1') || ''}</p>
    <div className="d-flex justify-content-between align-items-center">
      <p className="d-inline small m-0">{moment(createdAt).format('LLL')}</p>
    </div>
  </SimpleCard>
);

export default Notification;
